<div class="modal" data-cy="answer-preview-modal">
  <div class="spen-ly-modal spen-ly-static" id="modal">
    <div class="modal-dialog">
      <div class="inner">
        <div class="modal-heading">
          <span class="top-btn-close" (click)="closeModal()">
            <i class="fa fa-times" data-cy="close-preview-work" aria-hidden="true"></i>
          </span>
          <h2 class="heading-text">課題回答画面プレビュー</h2>
        </div>

        <div class="modal-content" #scrollable>
          @if (work) {
            <div class="work-info">
              <div class="spen-mod-heading lv-2 header-title">
                <h2 class="heading-text" data-cy="work-title">{{ work.title }}</h2>
              </div>
              <div class="user-info">
                <img data-cy="work-creator-avator" [src]="work.create_user.avatar" />
                <div class="text-info">
                  <p data-cy="work-creator-name">{{ work.create_user.name }}先生</p>
                </div>
              </div>
              @if (work.comment) {
                <div class="box-comment">
                  <span class="tip-up"></span>
                  <span class="tip-up-large"></span>
                  <p appConvertLink data-cy="work-comment">{{ work.comment }}</p>
                </div>
              }
              <div class="thumb row">
                @for (item of imageFiles; track item; let file_index = $index) {
                  @if (file_index < 4) {
                    <div class="thumb-item">
                      <div class="attach">
                        @if (item._file) {
                          <img appImagePreview [image]="item?._file" />
                        } @else {
                          <img src="{{ item.thumbnail }}" />
                        }
                        @if (showShadowBox(file_index)) {
                          <div class="overlay"></div>
                          <p class="number-attach">+{{ imageFiles.length - 3 }}</p>
                        }
                      </div>
                      @if (!showShadowBox(file_index)) {
                        <p class="file-name truncate-text">{{ getFileName(item) }}</p>
                      }
                    </div>
                  }
                }
                @for (item of notImageFiles; track item) {
                  <div class="file-item">
                    <div class="attach">
                      <div class="file-format"><i [ngClass]="getFileName(item) | fileIconClass"></i></div>
                    </div>
                    <p class="file-name truncate-text">{{ getFileName(item) }}</p>
                  </div>
                }
              </div>
            </div>
          }
          @if (!dataLoading()) {
            <div class="template">
              <p class="tem-heading">活動記録作成</p>
              <div class="btn-show-history">
                <p>過去の活動記録を見る</p>
              </div>
              <div class="form-answer-preview">
                <div class="form-group form-group-title">
                  <div class="row">
                    <p class="label-input">タイトル</p>
                    @if (work.answer_title) {
                      <p class="answer-title">{{ work.answer_title }}</p>
                    } @else {
                      <p class="input-text">入力してください</p>
                    }
                  </div>
                </div>
                @switch (convertWorkType(work.work_type)) {
                  @case ('single') {
                    <div>
                      <div class="form-group">
                        <div class="row">
                          <p class="label-input">本文</p>
                          <label class="select-input">
                            <div class="select">テンプレートを選択</div>
                            <i class="fa fa-caret-down"></i>
                          </label>
                          <p class="input-text input-textarea">入力してください</p>
                          <p class="text-num pull-right">文字数 <span class="num-character">0</span></p>
                          <label class="stu-add-file">
                            <i class="fa fa-paperclip"></i>
                            <span>ファイルを添付する</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  }
                  @case ('multiple') {
                    <div>
                      @for (question of workQuestions; track question; let i = $index) {
                        <div class="form-group work-questions">
                          <div class="row">
                            <div class="label-input">
                              設問{{ i + 1 }}
                              @if (isCompassWork) {
                                <span class="required">必須</span>
                              }
                            </div>
                          </div>
                          <div class="row">
                            <p class="work-question-content">{{ question.content.description || question.content }}</p>
                            @if (question.image || question.image_attributes) {
                              <div class="question-image">
                                <img src="{{ question.image?.thumbnail || question.image_attributes?.thumbnail }}" />
                              </div>
                            }
                          </div>
                          <div class="row">
                            @if (!question.content.description) {
                              <p class="input-text input-textarea">入力してください</p>
                              <p class="text-num pull-right">文字数 <span class="num-character">0</span></p>
                            } @else {
                              <div class="answer-options">
                                @for (option of question.content.options; track option) {
                                  <div class="answer-option">
                                    <label class="spen-mod-radio">
                                      <i class="fa"></i>
                                      <div class="option-text">{{ option }}</div>
                                    </label>
                                  </div>
                                }
                              </div>
                            }
                            <label class="stu-add-file">
                              <i class="fa fa-paperclip"></i>
                              <span>ファイルを添付する</span>
                            </label>
                          </div>
                        </div>
                      }
                    </div>
                  }
                }
                @if (work.category_name) {
                  <div class="form-group">
                    <div class="row">
                      <p class="category-text">{{ work.category_name }}</p>
                    </div>
                  </div>
                } @else {
                  <div class="form-group">
                    <div class="row">
                      <p class="label-input">カテゴリー</p>
                      <label class="select-input">
                        <div class="select">すべて</div>
                        <i class="fa fa-caret-down"></i>
                      </label>
                      <label class="select-input">
                        <div class="select select-disabled">すべて</div>
                        <i class="fa fa-caret-down"></i>
                      </label>
                    </div>
                  </div>
                }
                <div class="form-group group-mark">
                  <div class="row">
                    <p class="label-input">マーク</p>
                    <ul class="mark-select">
                      @for (mark of marks; track mark.id) {
                        <li class="spen-mod-checkbox">
                          <i class="fa"></i>
                          <img class="mark-icon" [src]="mark.icon" />
                          <span class="text">{{ mark.name }}</span>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            @if (!errorMsg && dataLoading()) {
              <div class="loading-item">
                <div class="spen-mod-flex-loading">
                  <div class="loading-icon"></div>
                </div>
              </div>
            }
          }
          <div class="modal-notice">
            <span>閲覧のみ</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
